module.exports = __webpack_public_path__ + "static/media/slider7img.c23eb105.jpg";